exports.default = {
  cases_ui: {
    "audio": "Audio",
    "gallery_eyebrow": "IDEAS · CREATIVE PROCESS",
    "gallery_title": "Video showcase",
    "gallery_description": "From storyboard images to the final film: see how an idea takes shape in conversation.",
    "categories": "Showcase categories",
    "all_categories": "All examples",
    "search": "Search video examples",
    "search_submit": "Search",
    "sort": "Sort examples",
    "recommended": "Recommended",
    "latest": "Latest",
    "popular": "Popular",
    "loading_cases": "Loading video examples",
    "loading_detail": "Loading the example and its creative process…",
    "cases_failed": "Video examples could not be loaded. Please try again.",
    "detail_failed": "This example is unavailable. It may have been unpublished or the link may have expired.",
    "categories_failed": "Categories could not be loaded. You can still browse all examples.",
    "empty_cases": "Video examples are on their way",
    "empty_cases_hint": "Discover finished videos and the conversations that turn storyboard images into a film.",
    "empty_search": "No examples match. Try another keyword or category.",
    "clear_filters": "Clear filters",
    "total": "{count} examples",
    "untitled": "Untitled video example",
    "open_case": "View example: {title}",
    "view_process": "Explore the process",
    "process_label": "MADE IN CONVERSATION",
    "detail_title": "Video creation example",
    "read_only": "Read-only · Historical tasks will not run or incur generation charges",
    "conversation": "Creative conversation",
    "preview": "Media preview",
    "outputs": "Generated media",
    "filter_media": "Filter generated media",
    "all": "All",
    "image": "Images",
    "video": "Videos",
    "reference": "Reference",
    "user": "User",
    "assistant": "AI assistant",
    "prompt": "Prompt",
    "empty_conversation": "No public conversation is included in this example.",
    "empty_media": "No generated media is available to preview.",
    "empty_filter": "No generated media of this type.",
    "select_media": "Preview {type}, item {index}",
    "media_failed": "This media could not be played or displayed. Please try again.",
    "continue_chat": "Continue conversation",
    "continuing": "Preparing conversation…",
    "continue_unavailable": "This example has no conversation context to continue. You can still preview its media.",
    "continue_failed": "Could not continue the conversation. Please try again. No message will be sent or video generated automatically.",
    "make_same": "Use as inspiration",
    "make_same_notice": "The prompt and settings supported by the current model have been filled in, but not sent. Original references were not imported. Use “Continue conversation” in the example for the full context and media.",
    "close": "Close",
    "dismiss": "Got it",
    "retry": "Try again",
    "share_failed": "This share could not be loaded. Please try again."
  },
  execution_regenerate_forbidden: "This video execution round cannot be regenerated. Refresh the original task, or request and confirm a new quote for another video.",
  retry_prepare_failed: "Could not prepare the retry. No new answer was started. Please try again.",
  execution_loading: "Preparing video generation tasks…",
  task_loading: "Loading video task…",
  task_media_pending: "Video generated. Retrieving playback URL…",
  execution_failed: "This video could not be submitted. See the details in this execution reply.",
  execution_unconfirmed: "This video is not confirmed yet. Checking the original task; please do not generate it again.",
  execution_refresh_failed: "Unable to update video status. Your current results are preserved. Refresh to try again.",
  title_brand: 'PAITEAMS',
  title: 'AI Video Studio',
  back: 'Back',
  entry_title: 'Choose a video entry',
  entry_caption: 'Aggregate entry',
  entry_default_desc: 'Orchestrate video generation capabilities',
  video_entry: 'Video studio',
  model_title: 'Choose a video agent',
  video_model: 'Video model',
  model_default_desc: 'For shots, motion, and scene generation',
  active: 'Active',
  config_title: 'Video parameters',
  config_caption: 'Follows the agent configuration',
  seconds: 'sec',
  advanced: 'Output options',
  sound: 'Audio',
  outputs: 'outputs',
  declared: 'Declared',
  pending: 'Pending',
  pending_adapter: 'This option is not enabled by the current execution adapter',
  config_note: 'The base path submits duration, resolution, and aspect ratio. Audio and K outputs wait for adapter support.',
  skill_title: 'Video skills and presets',
  optional: 'Optional',
  composer_kicker: 'VIDEO BRIEF',
  composer_title: 'Describe the scene you want to see',
  ready: 'Ready',
  waiting: 'Waiting for configuration',
  choose_model: 'Choose a video agent',
  choose_config: 'Choose a video agent first',
  reference: 'Reference images',
  reference_hint: 'Optional, helps keep the subject and style consistent',
  generate: 'Start generating',
  send_message: 'Send to agent',
  previous_quote_notice: 'The quote or task below retains its original inputs. Sending a new message does not confirm, cancel or resubmit it.',
  creating: 'Opening the agent conversation',
  no_entry: 'No video entry is available',
  no_models: 'No video agents are available',
  conversation_failed: 'Unable to create a video conversation. Try again shortly.',
  new_conversation: 'Video generation conversation',
  auth_notice: 'Sign in to choose a video agent and start creating.',
  login: 'Sign in',
  load_failed: 'Video agents are temporarily unavailable. Try again shortly.',
  back_home: 'Back home',
  agent: 'Video agent',
  choose_agent: 'Choose a video agent',
  no_entry_agents: 'No video entry agents are available',
  no_video_agents: 'No video models are available',
  loading: 'Loading video configuration',
  load_failed: 'Unable to load video configuration',
  retry: 'Retry',
  prompt_label: 'Describe the video you want to create',
  prompt_placeholder: 'For example: an 8-second product unboxing shot with steady camera motion and natural light.',
  reference_images: 'Reference images',
  add_reference: 'Add reference image',
  remove_reference: 'Remove reference image',
  settings: 'Video parameters',
  duration: 'Duration',
  select_duration: 'Select video duration',
  duration_range_hint: 'Duration must be between {min} and {max} seconds',
  seconds_short: 's',
  resolution: 'Resolution',
  aspect_ratio: 'Aspect ratio',
  frame_adaptive_ratio: 'Automatic',
  reference_all: 'All reference',
  first_last_frame: 'First / last frame',
  audio: 'Audio',
  generation_count: 'Outputs',
  output_count: 'Outputs',
  enabled: 'On',
  disabled: 'Off',
  adapter_unavailable: 'This option is not supported by the current execution adapter',
  skills: 'Video skills',
  presets: 'Preset categories',
  cases: 'Cases',
  recent: 'Recent work',
  empty_cases: 'No cases yet',
  empty_recent: 'No video conversations yet',
  start: 'Start creating',
  continue_chat: 'Open chat workspace',
  select_agent_first: 'Choose a video agent first',
  prompt_required: 'Describe the video first',
  agent_unavailable: 'This video agent is unavailable. Refresh the configuration.',
  config_source: 'Parameters come from the selected agent configuration',
  model: 'Model',
  default_config: 'Default configuration',
  video_agent: 'Video agent',
  skill_selected: 'Skill selected',
  preset_selected: 'Preset filled',
  case_selected: 'Case filled',
  chat_handoff_failed: 'Unable to open the video chat. Try again shortly.',
  signed_in_required: 'Sign in to start creating a video',
  video_preview: 'Video preview',
  play: 'Play',
  pause: 'Pause',
  download: 'Download',
  download_preparing: 'Preparing download...',
  download_failed: 'Download link failed. Click to retry',
  download_unavailable: 'Download is unavailable for this video',
  download_expired_refresh: 'This download link has expired. Refresh the page and try again.',
  download_ready_click: 'Your download link is ready. Click the download button again.',
  task_title: 'Video generation',
  task_generating: 'Your video is being generated',
  task_ready: 'Video generated',
  task_failed: 'Video generation failed',
  task_failed_detail: 'Please try again later or adjust the prompt and generate again.',
  task_status_pending: 'Queued',
  task_status_running: 'Generating',
  task_status_ready: 'Ready',
  task_status_failed: 'Failed',
  task_status_cancelled: 'Cancelled',
  task_status_unknown: "Task status unknown",
  task_parameters: {
    type: "Task type",
    reference: "Reference generation",
    edit: "Source video edit",
    follow_source_duration: "Original duration",
    follow_source_duration_value: "Original duration ({seconds} seconds)",
    adaptive_ratio: "Automatic aspect ratio",
    follow_source_ratio: "Original aspect ratio",
    follow_source_ratio_value: "Original aspect ratio ({ratio})",
    source_video: "Source video",
    source_dimensions: "Source {width} × {height}"
  },
  batch: {
    decision_declined: "No videos will be generated. No points were reserved.",
    progress: "Confirmed videos: {total} · completed: {completed} · failed or cancelled: {failed}",
    title: "Video quote options",
    member_count: "{count} independent videos",
    status_collecting: "Collecting quotes",
    status_ready: "Choose videos",
    status_decided: "Decision saved",
    status_invalidated: "Historical quotes",
    status_cancelled: "Cancelled",
    collecting_notice: "Quotes in this batch are still being collected. Selection becomes available when the batch is ready.",
    selection_label: "Select videos to generate",
    untitled: "Video option",
    hold: "Points to reserve",
    parameters: "Generation settings",
    points: "{points} points",
    seconds: "{seconds}s",
    script_source: "Script: {title} · revision {revision}",
    prompt_source: "Source: direct prompt",
    input_snapshot: "View generation content",
    input_unavailable: "Generation content is unavailable",
    associations: "View source and task links",
    quote_id: "Quote ID",
    batch_id: "Batch ID",
    script_id: "Script ID",
    decision_id: "Decision ID",
    dispatch_id: "Dispatch ID",
    task_id: "Task ID",
    select_all: "Select all",
    clear_selection: "Clear selection",
    selected_count: "{count} selected",
    total_hold: "Total to reserve",
    selected_total: "{count} videos selected · {points} points to reserve",
    balance: "Available team points: {points}",
    balance_unknown: "Awaiting verification",
    insufficient_points: "The selected reserve exceeds the available team balance. Select fewer videos or add points; the server performs the final check.",
    decision_notice: "Confirmation reserves points for the selected videos. Unselected videos will not be generated.",
    reject_all: "Skip generation",
    confirm_selected: "Confirm & generate",
    retry_same_decision: "Retry",
    settlement_not_ready: "These quotes cannot be confirmed. No points were reserved for this attempt. Request new quotes before confirming.",
    verify_failed: "Unable to load quotes. Refresh and try again.",
    scope_changed: "This account, team or conversation cannot access the batch.",
    quote_changed: "The quote revision, price or members changed. Refresh and review your selection.",
    action_failed: "The action could not be completed. Refresh and try again.",
    recovery_unavailable: "Unable to save this action. Allow browser storage, then refresh and try again.",
    decision_verify_failed: "Unable to update the status. Refresh and try again.",
    sync_pending: "Syncing status",
    sync_conflict: "Sync conflict · verification needed",
    confirmed_notice: "Confirmed. Waiting for AI to continue with these quotes.",
    quote_confirmation_required: "Awaiting confirmation",
    quote_confirmed: "Confirmed",
    quote_consumed: "Used",
    quote_rejected: "Declined · not generating",
    quote_invalidated: "Invalidated",
    quote_cancelled: "Cancelled",
    quote_unpriced: "Unable to quote",
    decision_saved: "Confirmed.",
    decision_committed: "Confirmed. Waiting to generate.",
    decision_waiting_sync: "Confirmation saved and syncing. AI continues after sync completes.",
    decision_pending_ai: "Confirmed. Waiting for AI execution.",
    decision_running_ai: "AI is processing the confirmed options.",
    decision_retry_wait: "Waiting to resume the original AI execution intent.",
    decision_cancelled: "This action was cancelled.",
    decision_expired: "The wait has ended. Refresh to check the status.",
    decision_needs_attention: "Generation status is unconfirmed. Refresh to check.",
    reason_user_declined: "This option was not selected. No video or task charge is created.",
    reason_quote_not_latest_round: "A new ordinary message closed this pending round. Ask AI for new quotes.",
    reason_superseded: "This quote round is historical.",
    reason_target_replaced: "A new quote replaced this target.",
    reason_script_revision_changed: "The script has a new revision. A new quote is required.",
    reason_pricing_changed: "Pricing rules changed. A new quote is required.",
    reason_unavailable: "Refresh the official state or request a new quote for this option.",
    task_unknown_notice: "The original submission state is unknown. Keep checking the same task; this does not mean failure, refund or permission to generate again."
  },
  quote: {
    legacy_read_only: "Historical quote: read-only. To generate another video, request a new quote in chat.",
    estimate_summary: 'Estimated {points} points, settled at actual cost',
    estimate_consent: 'By confirming, you agree to actual-cost billing: the estimate is held first. A lower actual cost is refunded automatically; a higher cost is automatically charged as a difference and may make available team points negative. The server blocks submission if the estimate exceeds available team points at confirmation.',
    actual_base: 'Actual base cost (before manual adjustments)',
    provisional_deducted: 'Provisional estimated charge (current net)',
    net_deducted: 'Current net charge',
    net_credit: 'Current net credit',
    estimate_difference: 'Actual cost minus estimate',
    charged_total: 'Cumulative charges',
    refunded_total: 'Cumulative refunds',
    supplemental_total: 'Cumulative supplemental charges',
    adjustment: 'Manual adjustment (+ charge, − refund)',
    settlement_source: 'Settlement evidence',
    source_unavailable: 'Awaiting settlement evidence',
    source_provider_cost: 'Verified provider cost',
    source_provider_usage: 'Verified provider usage',
    source_verified_spec: 'Verified successful output specification',
    source_estimate: 'Estimated cost (not measured usage)',
    billing_status_provisional: 'Billing: provisional estimated charge',
    billing_provisional: 'Provisionally charged the estimate of {points} points; {held} points remain held. Actual cost is not yet known. Verified cost will automatically refund or charge the difference, preserving manual adjustments. Automatic refresh is bounded; you can still refresh manually or return to verify.',
    billing_settled_v2: 'Verified actual base cost: {points} points. Current net charge or credit, manual adjustments and cumulative refunds are shown above. The original hold is closed: {released} points released, {held} still held. Hold release is not a cumulative refund or necessarily an increase in available points; expired or disabled credits are not restored.',
    billing_calculated_v2: 'Base cost awaiting verification: {points} points, not a final actual cost. Use the current net amount above for verified charges or credits.',
    billing_reason_estimate_fallback: 'Actual cost is not yet available. This is a provisional estimated charge; verified actual cost will automatically settle the difference. The estimate is not measured usage.',
    billing_reason_waiting_output: 'The success notification is verified, but the task video is still being saved. No charge has been made; the reservation remains held while the server retries verification.',
    dispatch_pending_v2: 'Confirmation holds the estimated {points} points before the server submits one video task. A hold is not a charge; billing then automatically settles at actual cost.',
    reservation_pending_v2: 'Confirmation holds the estimated {points} points, not a charge. Generation submission is not enabled yet; subsequent billing follows the confirmed actual-cost policy.',
    confirm_generate_v2: 'Confirm estimate of {points} points & generate',
    confirm_reserve_v2: 'Confirm & hold estimated {points} points',
    insufficient_points_v2: 'The estimate exceeds available team points, so the server blocked confirmation and submission. No charge was made. There is no automatic retry; refresh the quote status first.',
    actual_deducted: "Actually deducted",
    committed: "Committed / deducted",
    settled_at: "Settled at",
    billing_status_not_started: "Billing: not started",
    billing_status_reserved: "Billing: reserved",
    billing_status_awaiting_usage: "Billing: awaiting usage",
    billing_status_settled: "Billing: settled",
    billing_status_released: "Billing: released before submission",
    billing_status_manual_review: "Billing: manual review",
    billing_status_unpriced: "Billing: not priced",
    billing_status_unavailable: "Billing status unavailable",
    billing_awaiting_usage: "Waiting for verified usage before settlement. {held} points remain held. A ready video does not mean billing is settled; refresh remains available.",
    billing_settled: "Settlement verified: {points} points deducted, {released} reservation points released, and {held} points held. Released points do not necessarily increase the team balance; expired or disabled credits are not restored. Task progress is separate from settlement.",
    billing_manual_review: "Billing requires manual review. {held} points remain held and none have been deducted. Do not assume a refund or submit again. Automatic billing refresh is paused; you can refresh manually.",
    billing_unpriced: "Actual usage cannot be priced safely. {held} points remain held and none have been deducted. Unknown usage is not free generation or a refund. You can refresh manually.",
    billing_calculated: "Calculated for review: {points} points. This is not a deduction or permission to charge above the authorized maximum.",
    billing_reason_usage_missing: "Verified usage is missing. Do not treat missing usage as zero or assume the reservation was refunded.",
    billing_reason_authorization_exceeded: "Calculated usage exceeds the authorized limit and requires review. No extra charge or refund is assumed.",
    billing_reason_settlement_policy_unconfigured: "The frozen billing policy does not allow automatic settlement. Review is required.",
    billing_reason_failure_requires_review: "The task outcome requires billing review; failure alone does not release the reservation.",
    billing_reason_estimated_usage: "Estimated usage cannot finalize billing. Verified usage or review is required.",
    billing_reason_usage_source_untrusted: "Usage could not be verified for settlement. The reservation remains held.",
    billing_reason_usage_conflict: "Usage facts conflict and require review before settlement.",
    billing_reason_currency_mismatch: "Billing facts do not match the frozen quote and require review.",
    billing_reason_manual_review: "Billing requires manual review; no automatic refund is assumed.",
    billing_reason_unpriced: "Billing cannot be priced safely; this does not mean free generation.",
    billing_reason_unavailable: "Billing needs further verification. Use the verified amounts above, not an assumed charge or refund.",
    billing_reason_multiple_final_usage: "Multiple final usage records require review before settlement.",
    billing_reason_usage_payload_conflict: "Usage records conflict and require review before settlement.",
    billing_reason_retries_exhausted: "Automatic billing verification could not complete. Manual review is required.",
    billing_reason_invariant_violation: "Billing consistency could not be verified. No charge or refund is assumed.",
    billing_reason_invalid_pricing: "The frozen pricing rules cannot price this usage safely.",
    reason_dispatch_expired: "Submission authorization expired. The server cancelled the task before submission and released the reservation. Request a new quote and confirm again to generate.",
    confirm_generate: "Confirm reservation and submit generation",
    dispatch_pending: "Confirmation reserves up to {points} points before the server queues one video generation task. A reservation is not a charge.",
    dispatch_held: "{points} points remain held. Submission or task completion does not mean a charge. Only verified server state can release this hold, not quote expiry.",
    dispatch_status_queued: "Queued",
    dispatch_status_submitting: "Submitting",
    dispatch_status_accepted: "Accepted",
    dispatch_status_unknown: "Submission unknown",
    dispatch_status_rejected: "Rejected",
    dispatch_status_cancelled: "Submission cancelled",
    dispatch_queued: "Points are held and generation is queued. Cancellation is possible only before the worker starts submitting.",
    dispatch_submitting: "The server is submitting the generation task. Cancellation is unavailable and points remain held.",
    dispatch_accepted: "The generation request was accepted; this does not mean the video is ready or charged. See the verified task below for progress and results.",
    dispatch_unknown: "The submission outcome is unknown. Cancellation is unavailable and points remain held. Refresh server status; do not submit again.",
    dispatch_rejected: "The server verified rejection and invalidated this quote. The reservation was released; see the verified points record.",
    dispatch_cancelled: "The server verified cancellation before submission and released the reservation. Expired credits are not revived.",
    reason_dispatch_rejected: "Submission was rejected and this quote is invalid. To generate again, request a new quote and explicitly confirm it.",
    task_verify_failed: "Task ownership or progress could not be verified. No unverified result is shown. Refresh status; this does not release held points.",
    active_quote_retained: "This quote still has held points, a generation task or an unverified action outcome. Its original snapshot is retained. Editing inputs does not cancel it or submit again.",
    dispatch_state_unknown: 'The reservation could not be safely released. Cancellation or release has not been verified. Previously verified reservation details are unchanged; refresh the quote status. There is no automatic retry.',
    reason_reservation_unavailable: 'The reservation is unavailable and this quote is invalid. Request and review a new quote.',
    confirm_reserve: 'Confirm & reserve maximum {points} points',
    cancel_release: 'Cancel & release {points} points',
    held: 'Currently reserved (not deducted)',
    released: 'Released reservation points',
    reservation_id: 'Reservation ID',
    reservation_pending: 'Confirming will reserve the maximum authorized {points} points, not deduct them. Generation remains blocked and will not be submitted automatically.',
    reservation_held: '{points} points are currently reserved, not deducted. Video generation remains blocked and has not started.',
    reservation_released: 'Released a reservation of {points} points; currently reserved: {held}. Available points depend on the team balance; expired or disabled credits are not restored. No points were deducted and generation has not started.',
    reservation_none: 'No points are reserved or deducted for this quote, and video generation will not start.',
    expiry_release_pending: 'The quote has expired locally, but the last verified server state still has a reservation. Refresh its status or cancel to verify release; release is not yet confirmed.',
    insufficient_points: 'Insufficient available points to reserve the maximum. Confirmation failed and no points were deducted. There is no automatic retry; refresh the quote status first.',
    refresh_status: 'Refresh quote status',
    reason_billing_policy_changed: 'The reservation policy changed. This quote is no longer valid; request and review a new quote.',
    title: 'Video quote confirmation',
    create: 'Get video quote',
    creating: 'Preparing a quote for the current inputs',
    verifying: 'Verifying quote ownership and current status',
    confirm: 'Confirm this quote',
    cancel: 'Cancel quote',
    estimated: 'Estimated points',
    maximum: 'Maximum authorized points',
    points: '{points} points',
    unavailable: 'Unavailable',
    model_unavailable: 'Model unavailable',
    status_confirmation_required: 'Awaiting confirmation',
    status_confirmed: 'Confirmed, not submitted',
    status_cancelled: 'Cancelled',
    status_invalidated: 'Invalidated',
    status_expired: 'Expired',
    status_unpriced: 'Not priced',
    no_execution: 'Only your quote confirmation is recorded. No points are reserved or deducted, and video generation will not start.',
    single_output_notice: 'This quote supports one video output only; audio on/off selection is not supported.',
    confirmed_pending: 'Confirmation recorded, awaiting submission. Video generation has not started.',
    page_snapshot: 'This quote uses the saved inputs shown in the card, not the new message above. A new video tool request requires a separate quote and confirmation.',
    skill_snapshot: 'The skill may rewrite the prompt. This quote covers only the prompt snapshot shown below, not the final AI request.',
    quote_changed: 'The quote changed. Review the updated inputs and points before confirming again.',
    inputs_changed: 'Inputs or reference assets changed. This quote can no longer be confirmed.',
    scope_changed: 'Your account or team changed. This quote is no longer available in this session.',
    create_failed: 'Unable to prepare a confirmation quote. Retry with the current inputs.',
    tool_unavailable: 'The video quote is unavailable. No confirmation was recorded and generation has not started.',
    verify_failed: 'Unable to verify this quote. Confirmation is disabled until verification succeeds.',
    action_failed: 'The quote action could not be verified. Refresh its server status before trying again.',
    prompt_required: 'Enter a non-empty prompt to request a quote.',
    prompt: 'Prompt snapshot',
    reference_mode: 'Reference mode',
    references: 'Reference assets',
    no_references: 'None',
    breakdown: 'Quote breakdown',
    item: 'Item / unit',
    quantity: 'Quantity',
    billable_quantity: 'Billable quantity',
    expires: 'Expires at',
    rule_version: 'Pricing rule version',
    confirmed_at: 'Confirmed at',
    reason_context_changed: 'The model, inputs or reference assets changed. Request a new quote.',
    reason_pricing_changed: 'The pricing rule changed. Request a new quote.',
    reason_superseded: 'A newer quote replaced this quote. Review the latest quote before confirming.',
    reason_quote_expired: 'This quote has expired. Request a new quote.',
    reason_unavailable: 'This quote is currently unavailable for confirmation.'
  },
  constraints: {
    "error_dialog_title": "References do not meet the model requirements",
    "error_acknowledge": "Got it",
    "error_reference": "Reference {index}: {name}",
    "details": {
      "unsupported_file": "Unsupported media type or format.",
      "frames_images": "First/last frames must be images.",
      "type_count": "The selected model allows at most {max} references of this type.",
      "format": "Format {actual} is not allowed. Allowed: {allowed}.",
      "empty_file": "The file is empty.",
      "size": "Size is {actual} bytes; the maximum is {max} bytes.",
      "size_exclusive": "Size must be less than {max} bytes (actual: {actual}).",
      "minimum": "{field} is {actual}; minimum is {min}.",
      "maximum": "{field} is {actual}; maximum is {max}.",
      "codec": "Unsupported {field}: {actual}. Allowed: {allowed}."
    },
    "model_rules": "Up to {max} references under the current selection limit. Type limits and media requirements are checked separately; 50 is a system safety ceiling, not a provider joint limit.",
    "checking": "Checking local file metadata…",
    "unnamed": "Unnamed file",
    "total_count": "{actual} references selected; the current limit is {max}. Remove references explicitly or choose another model.",
    "mode": "The selected model does not support {mode}. Your references have been kept.",
    "unsupported_file": "Reference {index} “{name}”: unsupported media type or format.",
    "frames_images": "Reference {index} “{name}”: first/last frames must be images.",
    "type_count": "Reference {index} ({type} {typeIndex}) “{name}”: the selected model allows at most {max} of this type.",
    "format": "Reference {index} ({type} {typeIndex}) “{name}”: format {actual} is not allowed. Allowed: {allowed}.",
    "empty_file": "Reference {index} ({type} {typeIndex}) “{name}”: the file is empty.",
    "size": "Reference {index} ({type} {typeIndex}) “{name}”: {actual} bytes exceeds the {max}-byte limit.",
    "size_exclusive": "Reference {index} ({type} {typeIndex}) “{name}”: size must be strictly less than {max} bytes (actual: {actual}).",
    "minimum": "Reference {index} ({type} {typeIndex}) “{name}”: {field} is {actual}; minimum is {min}.",
    "maximum": "Reference {index} ({type} {typeIndex}) “{name}”: {field} is {actual}; maximum is {max}.",
    "codec": "Reference {index} ({type} {typeIndex}) “{name}”: {field} {actual} is not allowed. Allowed: {allowed}.",
    "total_duration": "Selected {type} duration totals {actual} ms; maximum is {max} ms.",
    "frames_first_required": "Select a first frame before choosing a last frame.",
    "frames_ratio_mismatch": "The first frame is {firstWidth}×{firstHeight} and the last frame is {lastWidth}×{lastHeight}. Their aspect ratios must match; pixel dimensions may differ. Replace one frame.",
    "audio_only": "This model requires an image or video reference with audio. Add one, remove the audio, or choose another model.",
    "pending": "Reference {index} ({type} {typeIndex}) “{name}”: pending server metadata check. Browser/unknown metadata is not a pass; playback failure is not generation failure.",
    "fields": {
      "width": "width (px)",
      "height": "height (px)",
      "ratio": "width/height ratio",
      "pixels": "pixel count",
      "duration_ms": "duration (ms)",
      "frame_rate": "frame rate (fps)",
      "video_codec": "video codec",
      "audio_codec": "audio codec"
    }
  },
  media: {
    reference_mode: 'Reference mode',
    scope_changed: 'Your account or team changed. Reopen the video conversation to continue.',
    "picker_title": "Choose video references",
    "selected": "Selected",
    "upload": "Upload files",
    "limits": "Up to {max} items, 50MiB each. PNG/JPEG/WebP, MP4/WebM/MOV, MP3/WAV/M4A/OGG.",
    "capability_notice": "Reference support depends on the model and provider. Unsupported inputs will be reported explicitly.",
    "image": "Images",
    "video": "Videos",
    "audio": "Audio",
    "all": "All",
    "asset_library": "Asset library",
    "filter": "Filter media type",
    "empty": "No matching assets yet. Upload files or load more.",
    "retry": "Retry",
    "load_more": "Load more",
    "cancel": "Cancel",
    "confirm": "Use selection",
    "remove_named": "Remove {name}",
    "preview_named": "Preview {name}",
    "unsupported_file": "Unsupported format. Choose one of the listed image, video or audio formats.",
    "file_too_large": "Files must be non-empty and no larger than 50MiB each.",
    "too_many": "Select up to {max} references.",
    "upload_failed": "Upload failed for {name}. Retry this file; successful uploads are retained.",
    "first_frame": "First frame",
    "last_frame": "Last frame",
    "replace": "Replace",
    "add": "Add reference",
     "reference_content": "Reference content",
    "reference_count": "{count} references",
     "expand": "Expand references",
     "collapse": "Collapse references",
     "clear_all": "Clear all media",
     "reference_all_prompt_placeholder": "Upload reference assets and enter text to freely combine images, text, audio, and video.",
     "first_last_frame_prompt_placeholder": "Enter text describing the scene and motion you want to create. Example: a 3D boy riding a skateboard in a park.",
    "preview": "Media preview",
    "preview_unavailable": "Preview unavailable",
    "preview_failed": "Preview is unavailable. Please retry.",
    "loading": "Loading preview…"
}
}
